import { useEffect, useState } from "react";
import { fabrics } from "../../scripts/fabrics";
import "./company-info.css";
import InfoModal from "../modals/infoModal";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Skeleton, Tooltip } from "antd";
import IconTag from "../icons/tag";
import IconRus from "../icons/rus";

type Props = {
  current: number;
};

const CompanyInfo = ({ current }: Props) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [item, setItem] = useState({});
  let type = localStorage.getItem("usertype");
  const closeModal = (value: any) => {
    setModalOpen(false);
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const properties = [
    {
      title: "Продукция",
      items: "бензин, реактивное и дизельное топливо, масла, битум, мазут",
    },
    {
      title: "Материалы сырья",
      items: "нефть, уголь, природный газ, древесина",
    },
    {
      title: "Оборудование",
      items:
        "ЭЛОУ-1, ЭЛОУ-3, ЭЛОУ-АТ-4, АВТ-3, АВТ-4, ЭЛОУ-АТ-4, вакуумная разгонка мазута ВТ-3 и ВТ-6, установка по производству битумов, висбрекинг, Л-35/11 и ЛГ-35/11, КР-600",
    },
  ];

  return (
    <>
      <div>
        <div>
          <div className="flex">
            <h2 className="module__title">{fabrics[current]?.title}</h2>{" "}
            <IconTag />
            <IconRus />
          </div>
          <div className="flex">
            <div>
              <span>ИНН:</span> {fabrics[current]?.inn}
            </div>
            <div>
              <span>КПП:</span> {fabrics[current]?.kpp}
            </div>
            <div>
              <span>ОГРН:</span> {fabrics[current]?.ogrn}
            </div>
          </div>
          <div>
            <span>ОКВЭД2:</span> {fabrics[current]?.okved}
          </div>
          {/*type == "industry" && (
            <div className=" card">
              <p className="block-title">Банковский рейтинг</p>
              <div className="flex">
                <Tooltip
                  color={"#4FD1C5"}
                  title="Процент роста/спада показателей, по сравнению с предыдущим периодом"
                >
                  <div className="flex-column gap-0_25 ">
                    {!loading ? (
                      <span className="description-span">8</span>
                    ) : (
                      <Skeleton
                        active
                        loading={loading}
                        paragraph={{ rows: 0 }}
                      />
                    )}
                    <span className="color-gray flex">
                      Кредитный рейтинг в банке
                      <InfoCircleOutlined className="info" />
                    </span>
                  </div>
                </Tooltip>
                <Tooltip
                  color={"#4FD1C5"}
                  title="Процент роста/спада показателей, по сравнению с предыдущим периодом"
                >
                  <div className="flex-column gap-0_25">
                    {!loading ? (
                      <span className="description-span">12</span>
                    ) : (
                      <Skeleton
                        active
                        loading={loading}
                        paragraph={{ rows: 0 }}
                      />
                    )}
                    <span className="color-gray flex">
                      Количество поданных заявок{" "}
                      <InfoCircleOutlined className="info" />
                    </span>
                  </div>
                </Tooltip>
                <Tooltip
                  color={"#4FD1C5"}
                  title="Процент роста/спада показателей, по сравнению с предыдущим периодом"
                >
                  <div className="flex-column gap-0_25">
                    {!loading ? (
                      <span className="description-span">93%</span>
                    ) : (
                      <Skeleton
                        active
                        loading={loading}
                        paragraph={{ rows: 0 }}
                      />
                    )}
                    <span className="color-gray flex">
                      Процент одобрения заявок{" "}
                      <InfoCircleOutlined className="info" />
                    </span>
                  </div>
                </Tooltip>
                <Tooltip
                  color={"#4FD1C5"}
                  title="Процент роста/спада показателей, по сравнению с предыдущим периодом"
                >
                  <div className="flex-column gap-0_25">
                    {!loading ? (
                      <span className="description-span">2 дня</span>
                    ) : (
                      <Skeleton
                        active
                        loading={loading}
                        paragraph={{ rows: 0 }}
                      />
                    )}
                    <span className="color-gray flex">
                      Среднее время обработки заявок
                      <InfoCircleOutlined className="info" />
                    </span>
                  </div>
                </Tooltip>
                <Tooltip
                  color={"#4FD1C5"}
                  title="Процент роста/спада показателей, по сравнению с предыдущим периодом"
                >
                  <div className="flex-column gap-0_25">
                    {!loading ? (
                      <span className="description-span">15%</span>
                    ) : (
                      <Skeleton
                        active
                        loading={loading}
                        paragraph={{ rows: 0 }}
                      />
                    )}
                    <span className="color-gray flex">
                      Финансовая нагрузка
                      <InfoCircleOutlined className="info" />
                    </span>
                  </div>
                </Tooltip>
              </div>
            </div>
                    )*/}
        </div>
        {type == "admin" && (
          <>
            <div className="mt-1_5 flex-column flex-row-sm gap-0_25 items-sm-stretch font-size-base">
              <div
                className="flex-column gap-0_25 items-sm-stretch"
                data-v-0d0ceb29=""
              >
                <span className="label px-1 py-0_25" data-v-0d0ceb29="">
                  ИНН 9724061893
                </span>
                <div className="card flex-column gap-1" data-v-0d0ceb29="">
                  <span className="card-header" data-v-0d0ceb29="">
                    ООО «Ветер Cпорт»
                  </span>
                  <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                    <span className="color-gray" data-v-0d0ceb29="">
                      Статус
                    </span>
                    <span data-v-0d0ceb29="">Действующая организация</span>
                  </div>
                  <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                    <span className="color-gray" data-v-0d0ceb29="">
                      Юр. адрес
                    </span>
                    <span data-v-0d0ceb29="">
                      121351,&nbsp;г&nbsp;Москва,&nbsp;ул&nbsp;Коцюбинского, д 4
                      стр 3, помещ 128
                    </span>
                  </div>
                  <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                    <span className="color-gray" data-v-0d0ceb29="">
                      Основной вид деятельности
                    </span>
                    <span data-v-0d0ceb29="">
                      {" "}
                      Производство спортивных костюмов, лыжных костюмов,
                      купальных костюмов и&nbsp;прочей трикотажной или вязаной
                      одежды (14.19.12){" "}
                    </span>
                  </div>
                </div>
              </div>
              <div
                className="flex gap-0_25 items-sm-stretch"
                data-v-0d0ceb29=""
              >
                <div className="card flex-column gap-1" data-v-0d0ceb29="">
                  <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                    <span className="color-gray" data-v-0d0ceb29="">
                      С/с численность
                    </span>
                    <span data-v-0d0ceb29="">32 сотрудника</span>
                  </div>
                  <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                    <span className="color-gray" data-v-0d0ceb29="">
                      Уставн. капитал
                    </span>
                    <span data-v-0d0ceb29="">100 000 ₽</span>
                  </div>
                  <div
                    className="flex-column gap-0_25 hidden-mobile"
                    data-v-0d0ceb29=""
                  >
                    <span className="color-gray" data-v-0d0ceb29="">
                      Реестр МСП
                    </span>
                    <span data-v-0d0ceb29="">
                      Микропредприятие с 10.12.2021
                    </span>
                  </div>
                  <div
                    className="flex-column gap-0_25 hidden-mobile"
                    data-v-0d0ceb29=""
                  >
                    <span className="color-gray" data-v-0d0ceb29="">
                      Специальный налоговый режим
                    </span>
                    <span data-v-0d0ceb29="">УСН</span>
                  </div>
                </div>
                <div
                  className="flex-column gap-0_125 flex-1"
                  data-v-0d0ceb29=""
                >
                  <div className="flex gap-0_125" data-v-0d0ceb29="">
                    <div
                      className="card flex-column gap-1 flex-1"
                      data-v-0d0ceb29=""
                    >
                      <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                        <span className="color-gray" data-v-0d0ceb29="">
                          Доходы
                        </span>
                        <span data-v-0d0ceb29="">
                          71&nbsp;277&nbsp;000&nbsp;₽
                        </span>
                      </div>
                      <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                        <span className="color-gray" data-v-0d0ceb29="">
                          Расходы
                        </span>
                        <span data-v-0d0ceb29="">
                          55&nbsp;019&nbsp;000&nbsp;₽
                        </span>
                      </div>
                    </div>
                    <div
                      className="card flex-column gap-1 hidden-mobile flex-1"
                      data-v-0d0ceb29=""
                    >
                      <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                        <span className="color-gray" data-v-0d0ceb29="">
                          Недоимки
                        </span>
                        <span data-v-0d0ceb29="">—</span>
                      </div>
                      <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                        <span className="color-gray" data-v-0d0ceb29="">
                          Штрафы
                        </span>
                        <span data-v-0d0ceb29="">—</span>
                      </div>
                    </div>
                  </div>
                  <div
                    className="card flex-column gap-1 hidden-mobile"
                    data-v-0d0ceb29=""
                  >
                    <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                      <span className="color-gray" data-v-0d0ceb29="">
                        Генеральный директор
                      </span>
                      <span data-v-0d0ceb29="">
                        Авдеенко Егор Павлович, ИНН 772586146371
                      </span>
                    </div>
                    <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                      <span className="color-gray" data-v-0d0ceb29="">
                        Учредители
                      </span>
                      <span data-v-0d0ceb29="">
                        Иванов&nbsp;Антон&nbsp;Анатольевич,
                        ИНН&nbsp;773131983956,&nbsp;90.00%&nbsp;доля
                      </span>
                      <span data-v-0d0ceb29="">
                        {" "}
                        ОБЩЕСТВО С ОГРАНИЧЕННОЙ
                        ОТВЕТСТВЕННОСТЬЮ&nbsp;"ЭЙЧ&nbsp;БИ&nbsp;ЭФ
                        ЭС",&nbsp;ИНН&nbsp;9714009735,&nbsp;10.00%&nbsp;доля{" "}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  className="card flex-column gap-1 hidden-mobile stretch"
                  data-v-0d0ceb29=""
                >
                  <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                    <span className="color-gray" data-v-0d0ceb29="">
                      КПП
                    </span>
                    <span data-v-0d0ceb29="">773101001</span>
                  </div>
                  <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                    <span className="color-gray" data-v-0d0ceb29="">
                      ОГРН
                    </span>
                    <span data-v-0d0ceb29="">1217700533192</span>
                  </div>
                  <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                    <span className="color-gray" data-v-0d0ceb29="">
                      ОКАТО
                    </span>
                    <span data-v-0d0ceb29="">45286590000</span>
                  </div>
                  <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                    <span className="color-gray" data-v-0d0ceb29="">
                      ОКТМО
                    </span>
                    <span data-v-0d0ceb29="">45320000000</span>
                  </div>
                  <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                    <span className="color-gray" data-v-0d0ceb29="">
                      ОКПО
                    </span>
                    <span data-v-0d0ceb29="">54610841</span>
                  </div>
                  <div className="flex-column gap-0_25" data-v-0d0ceb29="">
                    <span className="color-gray" data-v-0d0ceb29="">
                      ОКОГУ
                    </span>
                    <span data-v-0d0ceb29="">4210014</span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {type == "admin" && (
        <div>
          <div className="white-block grid4" style={{ gap: "15px" }}>
            <div className="flex-column gap-0_25">
              <span className="color-gray">Надежность</span>
              <span>{fabrics[current]?.trusted}</span>
            </div>
            <div className="flex-column gap-0_25">
              <span className="color-gray">Средняя надежность</span>
              <span>65</span>
            </div>
            <div className="flex-column gap-0_25">
              <span className="color-gray">Выручка</span>
              {(+65278880).toLocaleString()} руб.
            </div>
            <div className="flex-column gap-0_25">
              <span className="color-gray">Средняя выручка</span>
              {(+4527880).toLocaleString()} руб.
            </div>
            <div className="flex-column gap-0_25">
              <span className="color-gray">Расходы</span>
              {(+20860000).toLocaleString()} руб.
            </div>
            <div className="flex-column gap-0_25">
              <span className="color-gray">Прибыль</span>
              {(+86545).toLocaleString()} руб.
            </div>
            <div className="flex-column gap-0_25">
              <span className="color-gray">Загруженность</span>
              <span>350 дн.</span>
            </div>
            <div className="flex-column gap-0_25">
              <span className="color-gray">Средняя загруженность</span>
              <span>302 дн.</span>
            </div>
            <div className="flex-column gap-0_25">
              <span className="color-gray">
                Скорость производства(тонн/мес)
              </span>
              <span>{(+1404).toLocaleString()} тонн/мес </span>
            </div>
            <div className="flex-column gap-0_25">
              <span className="color-gray">
                Средняя скорость производства (тонн/мес)
              </span>
              <span>{(+1308).toLocaleString()} тонн/мес </span>
            </div>
            <div className="flex-column gap-0_25">
              <span className="color-gray">Скорость производства(руб.)</span>
              <span>{(+120444156).toLocaleString()} руб. </span>
            </div>
            <div className="flex-column gap-0_25">
              <span className="color-gray">
                Средняя скорость производства (руб.)
              </span>
              <span>{(+110059656).toLocaleString()} руб. </span>
            </div>
            <div className="flex-column gap-0_25">
              <span className="color-gray">Объем производства</span>
              <span>{(+38545).toLocaleString()} руб/мес</span>
            </div>
            <div className="flex-column gap-0_25">
              <span className="color-gray">Структура</span>
              <span>{(+150154).toLocaleString()}</span>
            </div>

            <div className="flex-column gap-0_25 red red-bg">
              <span className="color-gray">Нуждаемость в кадрах</span>
              <span>53</span>
            </div>
            <div className="flex-column gap-0_25">
              <span className="color-gray">Средняя нуждаемость в кадрах</span>
              <span>38</span>
            </div>
          </div>
        </div>
      )}
      {type == "admin" && (
        <div className="white-block grid3">
          {properties.map((property) => (
            <div className="grid-block gray-block">
              <div className="flex-space">
                <p className="block-title">{property.title}</p>
                {type == "industry" && (
                  <img
                    src="/settings.png"
                    alt="Редактировать"
                    onClick={() => {
                      setModalOpen(true);
                      setItem(property);
                    }}
                  />
                )}
              </div>
              <ul className="properties">
                {property.items.split(",").map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
      <InfoModal open={modalOpen} isCloseModal={closeModal} item={item} />
    </>
  );
};
export default CompanyInfo;
